"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const styles_1 = require("@material-ui/core/styles");
const core_1 = require("@material-ui/core");
const formik_1 = require("formik");
const useStyles = (0, styles_1.makeStyles)((theme) => ({
    root: {
        padding: '10px',
        fontSize: '16px',
        width: '100%',
        height: '200px',
    },
}));
const RenderTextAreaField = (props) => {
    const { field: { value, name, onChange, onBlur }, form: { touched, errors, setFieldValue, submitCount }, label, placeholder, rows, characterLimit, ...otherProps } = props;
    const error = (0, formik_1.getIn)(errors, name);
    const touch = (0, formik_1.getIn)(touched, name);
    const displayErrors = (touch || submitCount > 0) && !!error;
    return (react_1.default.createElement("div", { className: "p-0" },
        label && (react_1.default.createElement(Typography_1.default, { variant: "subtitle2", ...otherProps }, label)),
        react_1.default.createElement("div", { className: "border border-fadedGrey rounded" },
            react_1.default.createElement(core_1.TextField, { rows: rows, multiline: true, value: value || '', name: name, className: "border-0 border-transparent", onChange: onChange, placeholder: placeholder, InputProps: { disableUnderline: true, className: 'border-0 border-transparent' }, onBlur: (event) => {
                    setFieldValue(name, event.target.value.trim());
                    onBlur(event);
                }, ...otherProps }),
            characterLimit && (react_1.default.createElement(Typography_1.default, { className: "text-14 text-gray-400 ml-4" },
                Number((value === null || value === void 0 ? void 0 : value.length) || 0).toLocaleString(),
                "/",
                Number(characterLimit).toLocaleString()))),
        displayErrors && (react_1.default.createElement(Typography_1.default, { variant: "body2", component: "p", color: "error", className: "mt-2" }, error))));
};
RenderTextAreaField.defaultProps = {
    label: '',
};
RenderTextAreaField.propTypes = {
    field: prop_types_1.default.any.isRequired,
    form: prop_types_1.default.any.isRequired,
    label: prop_types_1.default.string,
    placeholder: prop_types_1.default.string,
    rows: prop_types_1.default.number.isRequired,
    characterLimit: prop_types_1.default.number,
};
exports.default = RenderTextAreaField;
